import React from "react";
import UserForm from "./UserForm";

export default function UserEdit() {
  return <UserForm mode="edit" />;
}
